import { createContext, useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import SsoHandler from "../utils/SSOhandler";
import localforage from "localforage";
import { useUserInfo } from "./user";
import { useAppServices } from "../hook/services";
import useDebouncedEffect from "../hook/debounce";
import env from "../config/env";
import { useNavigate, useParams } from "react-router-dom";
import ContactToSupportModal from "../components/ContactToSupportModal";
import toast from "react-hot-toast";
import moment from "moment-timezone";

const UsersContext = createContext();

const useUsersContext = () => useContext(UsersContext);

const UsersProvider = ({ children }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const { SSO, checkSSO } = SsoHandler();
  const userActiveLocation = useUserInfo()[4];
  const userInfo = useUserInfo()[0];
  const [openShareModal, setOpenShareModal] = useState(null);

  const [isActiveSide, setIsActiveSide] = useState(true);
  const [users, setUsers] = useState("");
  const [userTyping, setUserTyping] = useState({});
  const [isUserChating, setIsUserChating] = useState(false);
  const [agentPlaceholderText, setAgentPlaceholderText] = useState("");
  const [fromPromptMsg, setFromPromptMsg] = useState({});
  const [locationUsers, setLocationusers] = useState([]);
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const [products, setProducts] = useState([]);
  const [agents, setAgents] = useState([]);
  const [agentPageLoading, setAgentPageLoading] = useState(false);
  const [agentBuilder, setAgentBuilder] = useState(null);
  const [agency, setAgency] = useState(null);
  const [openAgentBuilder, setOpenAgentBuilder] = useState(false);
  const [useAgent, setUseAgent] = useState(false);
  const [isAuto, setIsAuto] = useState(true);
  const [conversationId, setConversationId] = useState("");
  const [conversations, setConversations] = useState({
    totalChats: 0,
    hasMore: false,
    data: [],
  });
  const [chatError, setChatError] = useState({
    showError: false,
    errorMessage: "",
    iconColor: "",
    classNames: "",
  });
  const [searchPageContent, setSearchPageContent] = useState({
    data: [],
    page: 1,
    limit: 30,
    total: 0,
  });
  const [tasksData, setTasksData] = useState([]);
  const navigate = useNavigate();
  const [openLimitModal, setOpenLimitModal] = useState(false);
  const params = useParams();
  const [messages, setMessages] = useState([]);
  const service = useAppServices();

  const getting_whitelable_domain = async () => {
    // Extract the domain from the current page URL
    const currentURL = window.location.href; // Get the full URL of the current page
    const urlObject = new URL(currentURL); // Create a URL object
    const domain = urlObject.hostname; // Extract the hostname (domain)
    const payload = {
      domain: domain, // Use the extracted domain
      // domain: "maybe.my-business.link",
    };
    let resp;
    resp = await service.agency.getwhitelabel({
      payload: payload,
    });

    if (resp.response?.data) {
      setAgency(resp?.response?.data);
      changeFavicon(resp?.response?.data);
    }
  };
  useEffect(() => {
    getting_whitelable_domain();
  }, []);

  const changeFavicon = (agency) => {
    // Replace 'new-favicon.ico' with the path to your new favicon
    const newFavicon = agency?.Customization?.chatapp_logo || "";

    // Create a new link element
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/x-icon";
    link.href = newFavicon;

    // Find the existing favicon link element in the head
    const head = document.head || document.getElementsByTagName("head")[0];
    const existingFavicon = document.querySelector("link[rel*='icon']");

    // If an existing favicon is found, remove it
    if (existingFavicon) {
      head.removeChild(existingFavicon);
    }

    // Append the new favicon link element to the head
    head.appendChild(link);
  };

  const [showExploreContent, setShowExploreContent] = useState(false);
  const [companyInfo, setCompanyInfo] = useState();
  const checkfreetrial = async (activeLocation) => {
    if (activeLocation?.id && activeLocation.type === "free_trail") {
      const response = await axios.get(
        `${BASE_URL}/auth/checktrail?location_id=${activeLocation?.id}`,
      );
      if (response) {
        return response;
      }
    }
  };
  const getLocationUsers = async (locationId) => {
    const fallbackLocation = await localforage.getItem("active_location");
    const activeLocationId =
      locationId || userActiveLocation?.id || fallbackLocation?.id;
    if (!activeLocationId) return;

    const response = await axios.get(
      `${BASE_URL}/user/chatusers?locationId=${activeLocationId}`,
    );
    if (response) {
      setLocationusers(response?.data?.data || []);
    }
  };

  const getOrCreateAgentBuilder = async () => {
    if (userInfo.role === "admin") {
      const response = await axios.post(`${BASE_URL}/assistant/agent-builder`, {
        profile_id: userActiveLocation?.id,
      });
      if (response?.data) setAgentBuilder(response?.data?.data?.assistant_id);
    }
  };

  const getSaasProducts = async () => {
    try {
      const { response } = await service.saas.agencysaas({
        query: `agency_id=${userActiveLocation?.agency_id}`,
      });
      if (response?.data) {
        let arraySaas = response?.data?.map((product) => ({
          ...product,
          activePlan: product._id === userActiveLocation?.plan_id,
          buttonLabel:
            product._id === userActiveLocation?.plan_id
              ? "Current plan"
              : "Upgrade plan",
        }));

        const hasActivePlan = arraySaas.find((product) => product.activePlan);
        if (!hasActivePlan) {
          arraySaas = arraySaas.map((product) => ({
            ...product,
            activePlan: product.is_free_saas === true,
            buttonLabel:
              product.is_free_saas === true ? "Current plan" : "Upgrade plan",
          }));
        } else {
          arraySaas = response?.data?.map((product) => ({
            ...product,
            activePlan: product._id === userActiveLocation?.plan_id,
            buttonLabel: product?.is_free_saas
              ? "Change plan"
              : product._id === userActiveLocation?.plan_id
                ? "Current plan"
                : hasActivePlan &&
                  (parseInt(hasActivePlan.monthly_amount) >
                    parseInt(product.monthly_amount) ||
                    parseInt(hasActivePlan.yearly_amount) >
                    parseInt(product.yearly_amount))
                  ? "Change plan"
                  : "Upgrade plan",
          }));
        }
        setProducts(arraySaas);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const isHighestPlan = () => {
    if (products.length === 0) return false;
    const sortedProducts = [...products]
      .filter((item) => item.isenable_account)
      .sort((a, b) => {
        const aPrice =
          userActiveLocation?.planType === "monthly"
            ? a.monthly_amount || 0
            : a.yearly_amount || 0;

        const bPrice =
          userActiveLocation?.planType === "monthly"
            ? b.monthly_amount || 0
            : b.yearly_amount || 0;
        return bPrice - aPrice;
      });
    return sortedProducts[0]._id === userActiveLocation?.plan_id;
  };

  useEffect(() => {
    userActiveLocation && getSaasProducts();
  }, [userActiveLocation]);

  // Function to toggle showExploreContent
  const enableExplore = () => {
    setShowExploreContent(true);
  };

  const enableChat = () => {
    setShowExploreContent(false);
  };

  const fetchAgentsArray = async () => {
    setAgentPageLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/assistant/fetchbyuser?user_id=${userInfo?._id}&location_id=${userActiveLocation?.id}`,
      );
      if (response) {
        let updatedResponse = [
          ...response.data.data.filter((item) => item.ui_enable),
        ];
        setAgents(updatedResponse);
        setAgentPageLoading(false);
        return updatedResponse;
      }
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
    setAgentPageLoading(false);
  };

  useDebouncedEffect(
    () => {
      if (userActiveLocation?.id) {
        getOrCreateAgentBuilder();
      }
    },
    [userActiveLocation],
    300,
  );

  const [toastState, setToast] = useState({ message: "", isVisible: false });

 
  const totalAttachedBytesRef = useRef(0);
  const resetAttachedFileSize = () => {
    totalAttachedBytesRef.current = 0;
  };
  const getAttachedFileSize = () => totalAttachedBytesRef.current;

  const showToast = (message) => {
    setToast({ message, isVisible: true });
    setTimeout(() => setToast({ message: "", isVisible: false }), 3000); // Auto-hide after 3 seconds
  };

  const hideToast = () => {
    setToast({ message: "", isVisible: false });
  };

  const hideLeftSidebar = () => {
    setIsActiveSide(false);
  };

  const showLeftSidebar = () => {
    setIsActiveSide(true);
  };

  const handleDeleteContact = async (contactId) => {
    const response = await axios.get(`${BASE_URL}/chat/delete?id=${contactId}`);
    return response;
  };

  const _updateUserProp = (userId, prop, value) => {
    setUsers((users) => {
      const usersCopy = [...users];
      let userIndex = users.findIndex((user) => user.id === userId);
      const userObject = usersCopy[userIndex];
      usersCopy[userIndex] = { ...userObject, [prop]: value };
      setUserTyping(usersCopy);
      return usersCopy;
    });
  };

  const checkUserAuth = async () => {
    return await localforage.getItem("user_data");
  };

  const onLoad = (SSO) => {
    // if (SSO != "" && SSO != undefined) {
    if (userActiveLocation?.id) {
      getLocationUsers(userActiveLocation.id);
    }
    getCompanyInfo();
    sessionstore();
    // }
  };
  const getCompanyInfo = async () => {
    const agency = await localforage.getItem("agency");
    if (agency?.agency_ghl) {
      try {
        const response = await axios.get(
          `${BASE_URL}/agency/companyinfo?company_id=${agency?.agency_ghl?.company_id}`,
        );
        if (response) {
          setCompanyInfo(response?.data?.data);
        }
      } catch (error) {
        console.error("Error fetching company info:", error);
      }
    }
  };
  const sessionstore = () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const sessionKey = url.searchParams.get("sessionKey");
    if (sessionKey) {
      localforage.setItem("sessionKey", sessionKey);
    }
  };
  useEffect(() => {
    onLoad(SSO);
  }, [SSO, userActiveLocation?.id]);
  useEffect(() => {
    checkSSO();
  }, []);

  const setUserAsUnread = (userId) => {
    _updateUserProp(userId, "unread", 0);
  };

  const contextuploadFilefrominput = async (
    files,
    chatId = "",
    setSpinnerLoading,
  ) => {
    const MAX_SINGLE_FILE_SIZE = 32 * 1024 * 1024;
    const MAX_COMBINED_FILE_SIZE = 50 * 1024 * 1024;
    const getRawFile = (item) => (item?.file ? item.file : item);
    const getFileSize = (f) =>
      Number(f?.size ?? f?.sizeBytes ?? f?.fileSize ?? f?.bytes ?? 0) || 0;

    let combinedSize = 0;
    for (let i = 0; i < files.length; i++) {
      const rawFile = getRawFile(files[i]);
      const size = getFileSize(rawFile);
      combinedSize += size;
      if (size > MAX_SINGLE_FILE_SIZE) {
        const msg = `${rawFile?.name || "File"}  exceeds the 32 MB file size limit. Please choose a smaller file`;
        toast.error(msg);
        if (setSpinnerLoading) setSpinnerLoading(false);
        return { status: false, message: msg };
      }
    }

    if (totalAttachedBytesRef.current + combinedSize > MAX_COMBINED_FILE_SIZE) {
      const msg = "Your selected files exceed the 50 MB upload limit. Remove some files or upload them in smaller batches.";
      toast.error(msg);
      if (setSpinnerLoading) setSpinnerLoading(false);
      return { status: false, message: msg };
    }
    totalAttachedBytesRef.current += combinedSize;

    // return 0
    const audioformData = new FormData();
    const formData = new FormData();
    const audiofilestype = [
      "audio/mpeg", // mp3
      "video/mp4", // mp4
      "video/mpeg", // mpeg
      "audio/mp4", // m4a
      "audio/wav", // wav
    ];
    const audiofiles = [];
    const otherFiles = [];
    let audioTranscript = "";
    let fileError = false;
    let errorMessage = "";

    for (let index = 0; index < files.length; index++) {
      const fileType = files[index].file?.type;

      if (audiofilestype.includes(fileType)) {
        audiofiles.push(files[index]);
      } else {
        otherFiles.push(files[index]);
      }
    }

    // Append allowed files to formData

    for (let file of audiofiles) {
      audioformData.append("file", file.file ? file.file : file);
      audioformData.append("translate", file.isChecked);
    }
    for (let file of otherFiles) {
      formData.append("file", file.file ? file.file : file);
    }
    audioformData.append("profile_id", userActiveLocation.id);
    audioformData.append("purpose", "context_wrapper");
    audioformData.append(
      "username",
      userInfo?.userName || userActiveLocation?.business_name,
    );
    audioformData.append("model_name", "openai/gpt-4o");
    formData.append("profile_id", userActiveLocation.id);
    formData.append(
      "username",
      userInfo?.userName || userActiveLocation?.business_name,
    );
    formData.append("model_name", "openai/gpt-4o");

    if (audiofiles.length > 0) {
      try {
        const response = await axios.post(
          `${BASE_URL}/chat/multimedia`,
          audioformData,
          {
            "Content-Type": "multipart/form-data", // Optional: axios sets this automatically
          },
        );
        if (response) {
          return response;
        }
        audioTranscript = response;
      } catch (error) {
        console.log(error);
        fileError = true;
      }
    }

    if (otherFiles.length > 0) {
      try {
        const response = await axios.post(
          `${BASE_URL}/chat/multimedia`,
          formData,
          {
            "Content-Type": "multipart/form-data", // Optional: axios sets this automatically
          },
        );
        if (response) {
          setSpinnerLoading(false);
          return response;
        }
      } catch (error) {
        setSpinnerLoading(false);
        fileError = true;
        errorMessage = error?.response?.data?.message;
      }
    }
    if (fileError) {
      setSpinnerLoading(false);
      return {
        status: fileError,
        transcript: audioTranscript,
        message: errorMessage,
      };
    } else {
      setSpinnerLoading(false);
      return {
        status: "uploaded",
        transcript: audioTranscript,
      };
    }
  };

  const contextUploadFileOnboarding = async (
    files,
    chatId = "",
    setSpinnerLoading,
  ) => {
    // return 0
    const audioformData = new FormData();
    const formData = new FormData();
    const audiofilestype = [
      "audio/mpeg", // mp3
      "video/mp4", // mp4
      "video/mpeg", // mpeg
      "audio/mp4", // m4a
      "audio/wav", // wav
    ];
    const audiofiles = [];
    const otherFiles = [];
    let audioTranscript = "";
    let fileError = false;
    let errorMessage = "";

    for (let index = 0; index < files.length; index++) {
      const fileType = files[index].file?.type;

      if (audiofilestype.includes(fileType)) {
        audiofiles.push(files[index]);
      } else {
        otherFiles.push(files[index]);
      }
    }

    // Append allowed files to formData

    for (let file of audiofiles) {
      audioformData.append("file", file.file ? file.file : file);
      audioformData.append("translate", file.isChecked);
    }
    for (let file of otherFiles) {
      formData.append("file", file.file ? file.file : file);
    }
    audioformData.append("profile_id", userActiveLocation.id);
    audioformData.append("purpose", "context_wrapper");
    audioformData.append("username", userActiveLocation?.business_name);
    audioformData.append("model_name", "openai/gpt-4o");
    formData.append("profile_id", userActiveLocation.id);
    formData.append("username", userActiveLocation?.business_name);
    formData.append("model_name", "openai/gpt-4o");

    if (audiofiles.length > 0) {
      try {
        const response = await axios.post(
          `${BASE_URL}/chat/multimediaForOnboarding`,
          audioformData,
          {
            "Content-Type": "multipart/form-data",
          },
        );
        if (response) {
          return response;
        }
        audioTranscript = response;
      } catch (error) {
        console.log(error);
        fileError = true;
      }
    }

    if (otherFiles.length > 0) {
      try {
        const response = await axios.post(
          `${BASE_URL}/chat/multimediaForOnboarding`,
          formData,
          {
            "Content-Type": "multipart/form-data", // Optional: axios sets this automatically
          },
        );
        if (response) {
          setSpinnerLoading(false);
          return response;
        }
      } catch (error) {
        setSpinnerLoading(false);
        fileError = true;
        errorMessage = error?.response?.data?.message;
      }
    }
    if (fileError) {
      setSpinnerLoading(false);
      return {
        status: fileError,
        transcript: audioTranscript,
        message: errorMessage,
      };
    } else {
      setSpinnerLoading(false);
      return {
        status: "uploaded",
        transcript: audioTranscript,
      };
    }
  };

  const fetchChats = async (page = 0) => {
    try {
      const skip = page === 0 ? 0 : (page - 1) * 50 + 50;
      const response = await axios.get(
        `${BASE_URL}/chat/filter?locationId=${userActiveLocation?.id}&userId=${userInfo?._id}&limit=${50}&skip=${skip}`,
      );
      const chats = response?.data?.data;
      const totalChats = response?.data?.totalChats;
      if (page === 0)
        setConversations({
          totalChats,
          data: chats,
          hasMore:
            page + 1 <
            Math.ceil(
              totalChats / (page === 0 ? 0 * 100 + 50 : (page - 1) * 100 + 50),
            ),
        });
      else
        setConversations((prev) => ({
          ...prev,
          totalChats,
          data: {
            favChats: [...prev?.data?.favChats, ...chats.favChats],
            today: [...prev?.data?.today, ...chats.today],
            yesterday: [...prev?.data?.yesterday, ...chats.yesterday],
            last7Day: [...prev?.data?.last7Day, ...chats.last7Day],
          },
          hasMore:
            page + 1 <
            Math.ceil(
              totalChats / (page === 0 ? 0 * 100 + 50 : (page - 1) * 100 + 50),
            ),
        }));
    } catch (err) {
      toast.error(err.response.data.message || err.message || err.toString());
    }
  };

  const fetchMessages = async (id) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/chat/messages?id=${id}&locationId=${userActiveLocation?.id}&userId=${userInfo?._id}`,
      );
      setMessages(response?.data?.data);
      return response?.data?.data;
    } catch (err) {
      toast.error(err.response.data.message || err.message || err.toString());
    }
  };
  const PENDING_CHAT_TTL = 15 * 60 * 1000; // 15 minutes
  const pendingPollRef = useRef(null);

  const pendingChatKey = (id) => `pendingChat:${id}`;

  const markChatPending = (id) => {
    if (!id) return;
    try {
      localStorage.setItem(pendingChatKey(id), String(Date.now()));
    } catch (e) { }
  };

  const clearChatPending = (id) => {
    if (!id) return;
    try {
      localStorage.removeItem(pendingChatKey(id));
    } catch (e) { }
  };

  const stopPendingPoll = () => {
    if (pendingPollRef.current) {
      clearInterval(pendingPollRef.current);
      pendingPollRef.current = null;
    }
  };

  const startPendingPoll = (id, startedAt) => {
    stopPendingPoll();
    pendingPollRef.current = setInterval(async () => {
      if (Date.now() - startedAt > PENDING_CHAT_TTL) {
        stopPendingPoll();
        clearChatPending(id);
        setIsUserChating(false);
        setAgentPlaceholderText(null);
        return;
      }
      const data = await fetchMessages(id);
      const list = Array.isArray(data) ? data : [];
      const last = list[list.length - 1];
      if (last && last.sender) {
        stopPendingPoll();
        clearChatPending(id);
        setIsUserChating(false);
        setAgentPlaceholderText(null);
      }
    }, 10000);
  };

  const resumePendingChat = (id, loadedMessages) => {
    if (!id) return;
    stopPendingPoll();
    let startedAt;
    try {
      startedAt = Number(localStorage.getItem(pendingChatKey(id)));
    } catch (e) {
      return;
    }
    if (!startedAt) return;
    if (Date.now() - startedAt > PENDING_CHAT_TTL) {
      clearChatPending(id);
      return;
    }
    const list = Array.isArray(loadedMessages) ? loadedMessages : [];
    const last = list[list.length - 1];
    // Reply already landed while the tab was away — nothing to wait for.
    if (last && last.sender) {
      clearChatPending(id);
      return;
    }
    setIsUserChating(true);
    setAgentPlaceholderText("Agent is thinking...");
    startPendingPoll(id, startedAt);
  };

  useEffect(() => {
    return () => stopPendingPoll();
  }, []);

  const isCreatingRef = useRef(false);

  const createConvesation = async (payload = {}) => {
    if (isCreatingRef.current) return;
    isCreatingRef.current = true;
    setIsUserChating(true);
    const hasAssistantOverride =
      Boolean(payload?.assistant_id) ||
      Boolean(payload?.assistant_name) ||
      Boolean(payload?.assistant_model_name);
    const activeAssistant = hasAssistantOverride
      ? {
        ...(payload?.assistant_model_name && {
          modal_name: payload.assistant_model_name,
        }),
        ...(payload?.assistant_id && { assistant_id: payload.assistant_id }),
        ...(payload?.assistant_name && {
          assistant_name: payload.assistant_name,
        }),
      }
      : selectedAssistant;
    const outgoingMessage = activeAssistant?.message || payload.message;
    const chatName = payload.title || outgoingMessage;

    try {
      const chatPayload = {
        locationId: userActiveLocation?.id,
        username: userInfo?.userName,
        userId: {
          id: userInfo?._id,
          type: "author",
          username: userInfo?.userName,
        },
        ...(activeAssistant?.assistant_name && {
          assistant_name: activeAssistant.assistant_name,
        }),
        ...(activeAssistant?.assistant_id && {
          assistant_id: activeAssistant.assistant_id,
        }),
        timezone: moment.tz.guess() || "UTC",
      };

      let conversationId = params.id;

      if (activeAssistant?.message !== "edit mode") {
        const response = await axios.post(`${BASE_URL}/chat`, chatPayload);

        const data = response.data.data;
        conversationId = data.conversation_id;

        const chat = {
          conversation_id: data.conversation_id,
          userId: data.userId,
          name: chatName,
          createdAt: data.createdAt,
        };

        if (
          activeAssistant?.assistant_name !== "Agent Builder" ||
          !activeAssistant?.assistant_name
        ) {
          setConversations((prev) => ({
            ...prev,
            data: {
              ...prev?.data,
              today: [chat, ...(prev?.data?.today ? prev?.data?.today : [])],
            },
          }));
        }

        navigate(`/app/chat/${conversationId}`);
      }

      const newMsgObject = {
        ...(payload.title ? { title: payload.title } : {}),
        content: outgoingMessage,
        sender: null,
        time: new Date().toLocaleTimeString(),
        status: "delivered",
        file_type: payload?.messagetype || "KB",
        assistant_name: activeAssistant?.assistant_name || "",
        file_ids:
          activeAssistant?.message === "edit mode" ||
            activeAssistant?.message === "force restart"
            ? []
            : payload?.fileData,
      };
      const messagePayload = {
        conversation_id: conversationId || activeAssistant?.conversationId,
        type: "savetodb",
        message: newMsgObject,
        assistant: activeAssistant,
      };

      if (payload?.addInMessages) {
        const messagePayload = payload.title ? { ...newMsgObject, content: newMsgObject.title } : newMsgObject
        setTimeout(() => setMessages((prev) => [...prev, messagePayload]), 500);
      }

      await handleSendMessage(messagePayload);
    } catch (err) {
      toast.error(err.response.data.message || err.message || err.toString());
    } finally {
      isCreatingRef.current = false;
      setSelectedAssistant({
        ...selectedAssistant,
        assistant_id: null,
        message: null,
        conversationId: null,
      });
    }
  };

  const handleSendMessage = async (payload) => {
    if (!isUserChating) setIsUserChating(true);
    stopPendingPoll();
    markChatPending(payload?.conversation_id);
    if (chatError.showError)
      setChatError({
        showError: false,
        errorMessage: "",
        classNames: "",
        iconColor: "",
      });
    setAgentPlaceholderText("Selecting an Agent...");
    const agentTimeout = setTimeout(() => {
      setAgentPlaceholderText("Agent Selected");
    }, 2000);
    const activeAssistant = payload?.assistant || selectedAssistant;
    const assistant = {
      modal_name:
        activeAssistant?.assistant_name === "Agent Builder"
          ? "openai/gpt-4o.1"
          : activeAssistant?.modal_name || "openai/gpt-4o",
      ...(activeAssistant?.assistant_id
        ? { assistant_id: activeAssistant?.assistant_id }
        : {}),
      ...(activeAssistant?.assistant_name
        ? { assistant_name: activeAssistant?.assistant_name }
        : {}),
    };
    try {
      const combinedPayload = {
        conversation_id: payload.conversation_id,
        type: payload.type,
        message: payload.message,
        username: userInfo?.userName,
        user_id: userInfo?.userId,
        agency_id: userActiveLocation?.agency_id,
        timezone: moment.tz.guess() || "UTC",
        assistant_model_name: assistant?.modal_name,
        ...(assistant?.assistant_id
          ? { assistant_id: assistant.assistant_id }
          : {}),
        ...(assistant?.assistant_name
          ? { assistant_name: assistant.assistant_name }
          : {}),
      };
      const { data: handled } = await axios.post(
        `${BASE_URL}/chat/handleChatMessage`,
        combinedPayload,
      );
      await fetchMessageResponse({
        userId: payload.conversation_id,
        assistant: assistant,
        aiResponse: handled?.data?.aiResponse,
      });
    } catch (error) {
      clearTimeout(agentTimeout);
      if (
        userActiveLocation?.type !== "free" &&
        error.response.data.errorType !== "balance"
      ) {
        setIsUserChating(false);
        setAgentPlaceholderText(null);
        navigate("/app/settings", {
          state: {
            tab: "Pricing",
            text: "Upgrade to add more AI Agent tasks",
          },
        });
      }
      const activePlan = products?.find((item) => item?.activePlan === true);
      if (
        (userActiveLocation?.type === "free" ||
          (!activePlan?.isenable_account && !activePlan?.developer_plan) ||
          isHighestPlan()) &&
        error.response.data.message === "Reached to limit"
      ) {
        setIsUserChating(false);
        setAgentPlaceholderText(null);
        setOpenLimitModal(true);
      }
      if (error.response.data.errorType === "balance") {
        setIsUserChating(false);
        setAgentPlaceholderText(null);
        setToast({ messages: error.response.data.message, isVisible: true });
        setTimeout(() => setToast({ message: "", isVisible: false }));
      }
    } finally {
      clearChatPending(payload?.conversation_id);
    }
  };

  function processLinks(response) {
    if (response === "" || response === null || response === undefined)
      return response;

    const buildAnchor = (url) => {
      if (url.includes("Export?id")) {
        return `<a
          href="${url}"
          download
          style="color:#34b0cb !important; cursor:pointer; text-decoration:underline;"
          rel="noopener noreferrer"
        >
          Click to download
        </a>`;
      }
      return `<a
        href="${url}"
        target="_blank"
        rel="noopener noreferrer"
        style="color:#34b0cb !important; cursor:pointer; text-decoration:underline;"
      >
        Click to view
      </a>`;
    };

    // Strip markdown code fences (```lang ... ```) so embedded anchors/URLs
    // render as clickable links instead of literal code.
    response = response?.replace(
      /```\w*\s*\n?([\s\S]*?)\n?```/g,
      "$1"
    );

    // Unwrap inline-code (`URL`) and angle-bracket (<URL>) decorations the
    // agent likes to add — otherwise the surrounding ` / < / > characters
    // get captured into the href below and break the rendered anchor.
    response = response?.replace(/`(https?:\/\/[^\s`]+)`/g, "$1");
    response = response?.replace(/<(https?:\/\/[^\s>]+)>/g, "$1");

    // Stash existing <a> tags first so they aren't double-matched by the
    // bare-URL pass below.
    const placeholders = [];
    const anchorRegex = /<a\b[^>]*\bhref\s*=\s*["']([^"']+)["'][^>]*>[\s\S]*?<\/a>/gi;
    response = response?.replace(anchorRegex, (_match, url) => {
      placeholders.push(buildAnchor(url.replace(/[`'"<>\s]+$/, "")));
      return ` ANCHOR_${placeholders.length - 1} `;
    });

    // Stash markdown links [text](url) as anchors too. Otherwise the bare-URL
    // pass below rewrites only the URL inside the parentheses, leaving broken
    // "[text](<a ...>)" markup that renders as a mangled link.
    const mdLinkRegex = /\[[^\]\n]*\]\((https?:\/\/[^\s)]+)\)/g;
    response = response?.replace(mdLinkRegex, (_match, url) => {
      placeholders.push(buildAnchor(url.replace(/[`'"<>\s]+$/, "")));
      return ` ANCHOR_${placeholders.length - 1} `;
    });

    // Regex to find all bare URLs in the remaining text. Exclude backticks
    // and quotes so we don't swallow neighbouring markdown into the href.
    const urlRegex = /(https?:\/\/[^\s<>"'`\[\]()]+)/g;
    response = response?.replace(urlRegex, (url) => {
      url = url?.replace(/[.,;:!?`)\]]+$/, "");
      return buildAnchor(url);
    });

    response = response?.replace(
      / ANCHOR_(\d+) /g,
      (_m, i) => placeholders[Number(i)]
    );

    return response;
  }

  const extractMessageText = (rawStream) => {
    if (!rawStream) return "";
    const lines = rawStream
      .split("\n")
      .filter((line) => line.startsWith("data: "));

    for (const line of lines) {
      try {
        const json = JSON.parse(line?.replace("data: ", ""));

        if (json.event === "thread.message.completed") {
          const contentArray = json.data?.content;
          const textObject = contentArray?.find((item) => item.type === "text");
          const value = textObject?.text?.value;

          return value; // ✅ This is your desired message
        }
      } catch (e) {
        console.warn("Invalid JSON line skipped:", line);
      }
    }

    return null;
  };

  const waitForRetry = (delay) =>
    new Promise((resolve) => setTimeout(resolve, delay));

  const fetchMessageResponse = async (data) => {
    const { userId, response, messagetype, fileData, assistant, aiResponse } =
      data;
    setTimeout(() => {
      setAgentPlaceholderText("Agent is thinking...");
    }, 4000);

    var msg = "";
    let responsesData;
    try {
      if (aiResponse !== undefined) {
        // The combined /chat/handleChatMessage endpoint already produced the reply.
        if (!aiResponse?.success) {
          const injectedError = new Error(
            aiResponse?.message || "Agent error",
          );
          injectedError.response = { data: aiResponse };
          throw injectedError;
        }
        responsesData = aiResponse;
      } else {
        let msg_data = JSON.stringify({
          conversation_id: userId,
          profile_id: userActiveLocation?.id,
          user_name: userInfo?.userName,
          prompt: response.content,
          file_ids: fileData?.map((item) =>
            item.id !== null && item.id !== undefined ? item.id : item.name,
          ),
          assistant_model_name: assistant?.modal_name,
          assistant_id: assistant?.assistant_id,
          user_id: userInfo.userId,
          assistant_name: assistant?.assistant_name,
          timezone: moment.tz.guess() || "UTC",
        });

        const retryDelays = [5000, 10000, 15000];
        const requestPayload = {
          data: msg_data,
          defualtModel: assistant?.modal_name,
          messagetype: messagetype,
          prompt: response?.content,
          agency_id: userActiveLocation?.agency_id,
          timezone: moment.tz.guess() || "UTC",
        };

        let responses;
        for (let attempt = 0; attempt <= retryDelays.length; attempt += 1) {
          try {
            responses = await axios.post(
              `${BASE_URL}/chat/message`,
              requestPayload,
            );
            break;
          } catch (error) {
            const status = error?.response?.status;
            const shouldRetry =
              (status === 502 || status === 504) &&
              attempt < retryDelays.length;
            if (!shouldRetry) {
              throw error;
            }

            await waitForRetry(retryDelays[attempt]);
          }
        }
        responsesData = responses?.data;
      }

      if (responsesData) {
        if (responsesData?.data?.data?.reply || responsesData?.data?.reply) {
          msg = processLinks(
            String(
              responsesData?.data?.data?.reply || responsesData?.data?.reply,
            ),
          );
        } else if (
          !responsesData?.data?.data &&
          responsesData?.data?.includes?.("thread.run.created")
        ) {
          const rawData = responsesData?.data;
          msg = extractMessageText(rawData);
        }
      }
    } catch (error) {
      const statusCode = error?.response?.status;
      const backendErrorMessage = String(
        error?.response?.data?.error?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong while getting the agent response.",
      );
      const isConversationError =
        backendErrorMessage.includes(
          "old threads are deprecated. Please start a new thread",
        ) || backendErrorMessage?.includes("Conversation with id");
      const showWarningStyle =
        statusCode === 500 ||
        backendErrorMessage.includes(
          "An error occurred while fetching the message",
        );
      setChatError({
        showError: true,
        errorMessage:
          statusCode === 500
            ? "This is not working right now. Please try again in a few minutes or contact us using the chat bubble bottom right."
            : backendErrorMessage.includes(
              "No assistant could handle this request",
            )
              ? "Opps looks like there is no agent that can handle this request. Please contact us using the chat bubble bottom right so we can get this fixed for you!"
              : backendErrorMessage.includes(
                "old threads are deprecated. Please start a new thread",
              ) || backendErrorMessage?.includes("Conversation with id")
                ? "We couldn't find this conversation. It may have been deleted or expired."
                : backendErrorMessage?.includes(
                  "Triage service did not return an assistant_id",
                ) ||
                  backendErrorMessage
                    ?.toLowerCase()
                    ?.includes("no agent set up for this yet")
                  ? "No agent set up for this yet. Lest's add one."
                  : backendErrorMessage?.includes(
                    "Triage selected an unknown assistant",
                  ) ? "This agent has been paused or removed" : backendErrorMessage?.includes('Another process is currently operating on this conversation') ? "Another process is currently operating on this conversation. Please wait a moment and try again." : backendErrorMessage,
        classNames:
          statusCode === 500 || backendErrorMessage?.includes('Another process is currently operating on this conversation')
            ? "!bg-[#FEF7E1] border !border-[#FEF7E1]"
            : !backendErrorMessage.includes(
              "old threads are deprecated. Please start a new thread",
            ) && !backendErrorMessage?.includes("Conversation with id")
              ? "!bg-[#F0F1FF] border !border-[#C4D0FF]"
              : "",
        iconColor:
          statusCode === 500 || backendErrorMessage?.includes('Another process is currently operating on this conversation')
            ? "#ECB24B"
            : !backendErrorMessage.includes(
              "old threads are deprecated. Please start a new thread",
            ) && !backendErrorMessage?.includes("Conversation with id")
              ? "#5768FF"
              : "",
      });
      setIsUserChating(false);
      return;
    }
    const newMsgObject = {
      content: msg,
      sender: userId,
      time: new Date().toLocaleTimeString(),
      status: null,
      assistant_name:
        responsesData?.data?.data?.assistant_name ||
        assistant?.assistant_name,
      plugins_used: responsesData?.data?.data?.plugins_used || [],
    };
    const payload = {
      message: newMsgObject,
      conversation_id: userId,
    };

    try {
      if (aiResponse === undefined) {
        await axios.post(BASE_URL + "/message/response", { ...payload });
      }
      await fetchMessages(userId);
    } catch (error) {
    } finally {
      setAgentPlaceholderText(null);
      setIsUserChating(false);
    }
  };

  useEffect(() => {
    if (!selectedAssistant?.assistant_id) return;
    createConvesation();
  }, [selectedAssistant]);

  const fetchSearchContent = async (search = "", page = 1, limit = 30) => {
    const response = await axios.get(
      BASE_URL +
      `/actions/search?userId=${userInfo?._id}&locationId=${userActiveLocation?.id}&search=${search}&page=${page}&limit=${limit}`,
    );
    if (response?.data?.success) {
      page === 1
        ? setSearchPageContent({
          ...response.data.data,
          hasMore:
            response?.data?.data?.page * response?.data?.data?.limit <
            response?.data?.data?.total,
        })
        : setSearchPageContent((prev) => ({
          ...prev,
          data: [...prev.data, ...response.data?.data?.data],
          hasMore:
            response?.data?.data?.page * response?.data?.data?.limit <
            response?.data?.data?.total,
        }));
    } else {
      toast.error(response.data?.message);
    }
  };

  const fetchTasksData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/prompts/prompt_data?userId=${userInfo?._id}&location_id=${userActiveLocation?.id}&agency_id=${userActiveLocation?.agency_id}`,
      );
      if (response?.data?.success) setTasksData(response?.data?.data);
      else toast.error(response?.data?.message);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const removeTasksFav = async (e, id) => {
    const response = await axios.get(
      `${BASE_URL}/chat/remove/favourite?chatId=${id}&user_id=${userInfo?._id}&location_id=${userActiveLocation?.id}`,
    );
    if (response?.data?.success) {
      fetchTasksData();
    } else toast.error(response?.data?.message);
  };

  const addTasksFavourite = async (e, id) => {
    const response = await axios.get(
      `${BASE_URL}/chat/add/favourite?prompt_id=${id}&user_id=${userInfo?._id}&location_id=${userActiveLocation?.id}`,
    );
    if (response?.data?.success) {
      fetchTasksData();
    } else toast.error(response?.data?.message);
  };

  return (
    <UsersContext.Provider
      value={{
        setUseAgent,
        useAgent,
        contextUploadFileOnboarding,
        contextuploadFilefrominput,
        resetAttachedFileSize,
        getAttachedFileSize,
        users,
        SSO,
        setUsers,
        setUserAsUnread,
        userTyping,
        hideLeftSidebar,
        showLeftSidebar,
        isActiveSide,
        handleDeleteContact,
        toast: toastState,
        showToast,
        hideToast,
        showExploreContent,
        enableExplore,
        enableChat,
        fromPromptMsg,
        getLocationUsers,
        locationUsers,
        companyInfo,
        checkfreetrial,
        selectedAssistant,
        setSelectedAssistant,
        products,
        setCompanyInfo,
        agentPageLoading,
        agents,
        fetchAgentsArray,
        agentBuilder,
        setOpenAgentBuilder,
        openAgentBuilder,
        conversationId,
        setConversationId,
        isAuto,
        setIsAuto,
        agency,
        isHighestPlan,
        fetchChats,
        conversations,
        fetchMessages,
        resumePendingChat,
        messages,
        setMessages,
        agentPlaceholderText,
        isUserChating,
        handleSendMessage,
        createConvesation,
        openShareModal,
        setOpenShareModal,
        chatError,
        setChatError,
        fetchSearchContent,
        searchPageContent,
        fetchTasksData,
        tasksData,
        addTasksFavourite,
        removeTasksFav,
        setIsUserChating
      }}
    >
      {children}
      <ContactToSupportModal
        isOpen={openLimitModal}
        onClose={() => setOpenLimitModal(false)}
      />
    </UsersContext.Provider>
  );
};

export { useUsersContext, UsersProvider };
